import { render, staticRenderFns } from "./codification-rejas.vue?vue&type=template&id=2038d24c"
import script from "./codification-rejas.vue?vue&type=script&lang=js"
export * from "./codification-rejas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports